<template>
    <div class="alert-maxi-standalone">
        <iframe ref="frame" :src="getUrl" :class="{'with-button':isAcked}"></iframe>
        <Btn class="block primary reverse" v-if="isAcked" v-html="$t('alerts.btns.printRecord')" @click.native.stop="printAlertRecord"></Btn>
        <LoadingMini ref="loading"></LoadingMini>
    </div>
</template>

<script>
  import moment from 'moment'

  import LoadingMini from '@/components/ui/LoadingMini';
  import Btn from '@/components/ui/Button';
  import axios from 'axios';
  import API from '@/services/API.js';
  import report from '@/services/report'
  import Auth from '@/services/auth.js';
  import Utils from '@/services/utils'
  import { getChatUrl } from './getChatUrl'

  export default {
    name: 'alert-modal',
    components: {
      LoadingMini,
      Btn
    },
    props: {
      props: {
        type: Object,
        default: null,
      }
    },
    data () {
      return {
        ack: false
      }
    },
    mounted: function () {
      this.handleLoading();
    },
    computed: {
        getUrl: function(){

            if(this.props != null){
                return this.getChatUrl({
                    url: this.props.url,
                    Auth,
                    window
                })
            }
            return null;

        },
        isAcked: function(){
            return this.props.ack || this.ack;
        },
        isAckable: function(){
            if(this.props.id){
                return true;
            }
            return false;
        }
  },
    methods: {
        getChatUrl,
        handleLoading: function(){
            this.ack = false;
            this.$refs.loading.show();

            this.$refs.frame.onload = () => {
                this.$refs.loading.hide();
                this.$refs.frame.onload = null;
            }
        },
        dismissAlert(){
            this.$refs.loading.show();
            axios.put(API.route(API.endpoints.alerts.dismiss,{id:this.props.id}))
                .then(response => {
                    this.ack = true;
                    window.Vfc.blurMode(false);
                    window.Vfc.$refs.modal.hide();
                    this.$refs.loading.hide();
                    if(this.props.dismissCallback != null){
                        this.props.dismissCallback();
                    }
                })
        },
        printAlertRecord(){
            report.dlAlertRecord(this.props.id,Utils.t('reports.reports.alertRecord.title')+' '+Utils.alertNumberFormated(this.props.id)+' '+Utils.t('global.fromToDate1')+' '+moment(this.props.eventAt).format(Utils.t('datetime.reportDateTimeComplete'))).then(()=> {
                element.querySelector('.event-infos .alert-record-report-btn .fa-spin').classList.add('fa-hidden')
                element.querySelector('.event-infos .alert-record-report-btn .fa-file-text').classList.remove('fa-hidden')
            })
        }
    },
    watch: {
        'props.url': function(newValue){
            this.handleLoading();
        }
    }
  }
</script>
